import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { initialIndividualState } from "../../../../static/initialState/commonInitialState/individualInitialState";
import { LegalEntityWithRepresentativeInitialState } from "../../../../static/initialState/commonInitialState/legalEntityInitalState";
import { managerWithRepresentativeInitalState } from "../../../../static/initialState/limited-company-creation/managerWithRepresentativeInitialState";
import { ManagerWithRepresentativeType } from "../../../../static/types/limited-company-creation/managerWithRepresentativeType";
import { entityTypes } from "../../../../static/types/objectType";
import IndividualPerson from "../../../commonComponents/IndividualPerson";
import LegalEntityWithRepresentative from "./LegalEntityWithRepresentative";

type ManagerListProps = {
    checked: boolean,
    societyTypeOptions: string[],
    managers: ManagerWithRepresentativeType[],
    addButtonText: string,
    removeButtonText: string,
    representativeLabel: string,
    labelItem?: string,
    draftFieldName?: string,
    min?: number,
    setManagers: ( managers: ManagerWithRepresentativeType[] ) => void
    setManagersValidity: ( isValid: boolean ) => void
}

export default function ManagerListWithRepresentative({
    checked,
    societyTypeOptions,
    managers,
    labelItem,
    representativeLabel,
    min,
    setManagers,
    addButtonText,
    removeButtonText,
    setManagersValidity,
    draftFieldName
}: ManagerListProps) {

    
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    let listValidity: boolean[] = [ false ]

    const addManager = () => {
        setManagers([
            ...managers,
            managerWithRepresentativeInitalState
        ]);
        listValidity.push( false )

         let draft = parseDraft()
        const tempDraft = { ...draft, [ draftFieldName || 'managersWithRepresentative' ]: [
            ...managers,
            managerWithRepresentativeInitalState
        ]}
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const removeLastManager = () => {
        if (managers.length > 1) {
            setManagers(managers.slice(0, -1));
            let draft = parseDraft()
            const tempDraft = { ...draft, [ draftFieldName || 'managersWithRepresentative' ]: managers.slice(0, -1)}
            setDraftFormData( stringifyDraft( tempDraft ))
        }
        if (listValidity.length > 1) {
            listValidity.slice(0, -1)
        }
    };

    const updateManager = (index: number, updatedManager: ManagerWithRepresentativeType) => {
        const newManagers = [...managers];
        newManagers[index] = updatedManager;
        setManagers(newManagers);
        let draft = parseDraft()
        const tempDraft = { ...draft, [ draftFieldName || 'managersWithRepresentative' ]: newManagers }
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const toggleManagerType = ( person: "Personne physique" | "Personne morale", index: number) => {

        const newManager: ManagerWithRepresentativeType = person === "Personne physique"
        ? {
            person: "Personne physique", 
            personDetails: initialIndividualState
            } 
        : {
            person: "Personne morale", 
            entityDetails: LegalEntityWithRepresentativeInitialState
            }
        
        updateManager(index, newManager);
    };

    const updateManagersValidity = (index: number, isValid: boolean) => {
        listValidity[index] = isValid;
        setManagersValidity( listValidity.every( valid => valid ) );
    };

    return (
        <>
            <div className="mb-3 row">
                {
                    managers.map((manager, index) =>

                        <div key={index} className="tab-content mb-2">

                            <div className = "mb-3 row pt-3">

                                <div className = "mb-3 row">
                                    <div className = "col-sm-10">
                                        { labelItem ? <h6 className='text-bold'>{ `${labelItem} ${ index + 1 }` }</h6> : "" }
                                    </div>
                                </div>

                                <div className = "mb-3 row">

                                    <label htmlFor="personne" className = "col-sm-2 col-form-label">Personne</label>

                                    <div className = "col-sm-10">
                                        <select
                                            className = "form-select"
                                            id = "person"
                                            onChange = { e => toggleManagerType(
                                                e.target.value as "Personne physique" | "Personne morale",
                                                index
                                            ) }
                                            value = { manager?.person || "" }
                                        >
                                            {
                                                entityTypes.map( option => 
                                                    <option key = { option } value = { option }>
                                                        { option }
                                                    </option>
                                                )
                                            }
                                        </select>
                                    </div>

                                </div>
                            </div>

                            {
                                manager.person === "Personne physique"
                                ?
                                <IndividualPerson
                                    checked = { checked }
                                    onValidationChange = { (isValid: boolean) => updateManagersValidity( index, isValid ) }
                                    individual = { manager.personDetails } 
                                    changeIndividual= { details => {
                                        const updatedManager: ManagerWithRepresentativeType = {
                                            ...manager,
                                            personDetails: { ...manager.personDetails, ...details }
                                        };
                                        updateManager( index, updatedManager );
                                    }}
                                />
                                : 
                                <LegalEntityWithRepresentative
                                    representativeLabel = { representativeLabel }
                                    checked = { checked }
                                    onValidationChange = { (isValid: boolean) => updateManagersValidity( index, isValid ) }
                                    societyType = { societyTypeOptions }
                                    legalEntity = { manager.entityDetails } 
                                    changeLegalEntity = { details => {
                                        const updatedManager: ManagerWithRepresentativeType = {
                                            ...manager,
                                            entityDetails: { ...manager.entityDetails, ...details }
                                        };
                                        updateManager( index, updatedManager );
                                    }}
                                />
                            }
                        </div>
                    )
                }
            </div>

        <div className="row mb-3">
            <div className="col d-flex justify-content-center align-items-center gap-5">
                <button type='button' onClick = { addManager }> {addButtonText} </button>
                {
                    (
                        ( min && managers.length > min ) ||
                        ( !min && managers.length > 1 ) 
                    )
                    && 
                    <button type='button' onClick = { removeLastManager }> {removeButtonText} </button>
                }
            </div>
        </div>
    </>
  );
};